module.exports = __webpack_public_path__ + "static/media/dice-d8.a0eadfe9.svg";